import { combineReducers } from 'redux'
import { persistReducer, createTransform } from "redux-persist";
import storageSession from 'redux-persist/lib/storage/session';
import JSOG from 'jsog'

import userReducer from './action/user'
import loadingReducer from './action/loading'
import commonReducer from './action/common'
import masterTableReducer from './action/masterTable'
import bplCreateReducer from './action/BPLCreate'
import tdSelectorReducer from './action/TDSelector';



const JSOGTransform = createTransform(
    (inboundState, key) => JSOG.encode(inboundState),
    (outboundState, key) => JSOG.decode(outboundState),
)

const persistConfig = {
	key: "root",
	// sessionStorage에 저장합니다.
	storage: storageSession,
	// reducer 중에 user reducer만 localstorage에 저장합니다.
	whitelist: ["user", "common"],
	// blacklist -> 그것만 제외합니다
	transforms: [JSOGTransform]
  };
  
const rootReducer = combineReducers({
	user: userReducer,
	loading: loadingReducer,
	common: commonReducer,
	masterTable: masterTableReducer,
	sheet:  bplCreateReducer,
	tdSelector: tdSelectorReducer,
})



export default persistReducer(persistConfig, rootReducer);
